/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FoundOperationalFileTransport { 
    id?: number;
    transportModeValue?: FoundOperationalFileTransport.TransportModeValueEnum;
    transportMode?: string;
    companyName?: string;
    partyType?: string;
}
export namespace FoundOperationalFileTransport {
    export type TransportModeValueEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    export const TransportModeValueEnum = {
        NUMBER_0: 0 as TransportModeValueEnum,
        NUMBER_1: 1 as TransportModeValueEnum,
        NUMBER_2: 2 as TransportModeValueEnum,
        NUMBER_3: 3 as TransportModeValueEnum,
        NUMBER_4: 4 as TransportModeValueEnum,
        NUMBER_5: 5 as TransportModeValueEnum,
        NUMBER_6: 6 as TransportModeValueEnum,
        NUMBER_7: 7 as TransportModeValueEnum,
        NUMBER_8: 8 as TransportModeValueEnum,
        NUMBER_9: 9 as TransportModeValueEnum
    };
}